// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"af2e016b8da804a60a6d","339":"356e1f904bf0a1ba8fba"}[chunkId] + ".js";
};